import React from "react";
import { Box, Grid, Slide, useScrollTrigger } from "@material-ui/core";

import { Section } from "../components";
import "../styles/index.scss";
import { en } from "../content";

function Experience({ scrollThreshold, isMobile }) {
  const content = en.experience;
  const scrollTrigger = useScrollTrigger({
    threshold: scrollThreshold,
    disableHysteresis: true,
  });

  return (
    <Box
      className={`experience ${
        isMobile ? "experienceMobile" : "experienceDesktop"
      }`}
      top={0}
      position={isMobile ? "relative" : "sticky"}
    >
      <Section>
        <Box>
          <Box className="banner" mb={4}>
            {content.title}
          </Box>
          {content.experience.map((item, i) => (
            <Slide
              in={scrollTrigger}
              timeout={1000 * (i + 1)}
              direction={i % 2 === 0 ? "left" : "right"}
              key={item.company}
            >
              <Box className="subsection" mt={i > 0 ? 4 : 0}>
                <Grid
                  container
                  display="flex"
                  width="100%"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  className="titleBox"
                >
                  <Grid item xs={12} md={6}>
                    <Box
                      item
                      className="company"
                      display="flex"
                      width="100%"
                      alignItems="center"
                      justifyContent="flex-start"
                    >
                      {item.company}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box
                      item
                      className="time"
                      display="flex"
                      width="100%"
                      alignItems="center"
                      justifyContent={isMobile ? "flex-start" : "flex-end"}
                    >
                      {item.time}
                    </Box>
                  </Grid>
                </Grid>
                <Box fontStyle="italic" my={1}>
                  {item.title}
                </Box>

                <Box>
                  {item.description.map((desc) => (
                    <Box key={desc} display="flex" alignItems="flex-start">
                      <Box mr={1}>•</Box> {desc}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Slide>
          ))}
        </Box>
      </Section>
    </Box>
  );
}

export default Experience;
